import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { PageKeyAccessType, LeftRightWrapper, LocalService, Status, PageKey, AccessRole } from '../../../service/local.service';

@Component({
  selector: 'app-allowed-actions',
  templateUrl: './allowed-actions.component.html',
  styleUrls: ['./allowed-actions.component.scss']
})
export class AllowedActionsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["left_right_selection"];
  id: string; wrapper: LeftRightWrapper; pageKey: PageKey = PageKey.None; accessRole: AccessRole = AccessRole.None;
  strPageKey = ''; strAccessRole = '';
  constructor(public localService: LocalService, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.id = routeParams.id;
      this.pageKey = routeParams.pageKey;
      this.accessRole = routeParams.role;
      this.strPageKey = PageKey[this.pageKey];
      this.strAccessRole = AccessRole[this.accessRole];
      this.onLoad();
    });
  }

  onLoad() {
    this.configurationManagementService.getAllowedActionsSetup(this.pageKey, this.accessRole).subscribe(result => {
      this.wrapper = result;
    });
  }

  onSave(selectedItems) {
    this.configurationManagementService.saveAlowedActions(selectedItems, this.pageKey, this.accessRole).subscribe(result => {
      this.onLoad();
      switch (result.status) {
        case Status.RangeNotAllowed: {
          this.localService.showMessage(this.localService.languageContent.left_right_selection.need_page_key);
        } break;
      }
    });
  }
}
